import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-edit-site',
  templateUrl: './edit-site.component.html',
  styleUrls: ['./edit-site.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditSiteComponent {
  constructor(
    private route: ActivatedRoute,
    private ToastService: ToastService
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const SiteId = ParamMap.get('SiteId');
        const CompanyId = ParamMap.get('CompanyId');

        if (!SiteId) {
          throw this.ToastService.addErrorToast('Error', 'Missing site id.', {
            returnError: true
          });
        }

        if (!CompanyId) {
          throw this.ToastService.addErrorToast('Error', 'Missing Client id.', {
            returnError: true
          });
        }

        this.CompanyId = Number(CompanyId);
        this.SiteId = Number(SiteId);
      }
    });
  }

  CompanyId!: number;
  SiteId!: number;
}
